module.exports = __webpack_public_path__ + "images/email/avatar-50-d697be5bef527c52f0fec7be74141ce3.png";